import React, { forwardRef } from 'react';

const IcStatusWarning = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties,
  ref
}, /* @__PURE__ */ React.createElement("path", {
  d: "M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
  fill: "var(--warning-icon-default)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M7.2 4.8a.8.8 0 1 1 1.6 0v3.4a.8.8 0 0 1-1.6 0V4.8Z",
  fill: "var(--info-icon-in-default)"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--info-icon-in-default)",
  height: "2",
  rx: "1",
  width: "2",
  x: "7",
  y: "10"
})));

export { IcStatusWarning };
//# sourceMappingURL=ic-status-warning.js.map
